// eslint-disable-next-line
export default {
  icons: {
    logo: require("@src/assets/logo.svg").default,
    rightArrow: require("@src/assets/icons/blackRightArrow.svg").default,
    orderRightArrow: require("@src/assets/icons/orderArrow.svg").default,
    swap: require("@src/assets/icons/swap.svg").default,
    group: require("@src/assets/icons/group.svg").default,
    limitOrderArrow: require("@src/assets/icons/limitOrderArrow.svg").default,
    arrowDown: require("@src/assets/icons/arrowDown.svg").default,
    arrowDownWithBorder: require("@src/assets/icons/lightArrowWithBorder.svg").default,
    done: require("@src/assets/icons/done.svg").default,
    add: require("@src/assets/icons/whiteAdd.svg").default
  }
};
